module.exports = __webpack_public_path__ + "img/SWP_Shield_05 (1).04d59ebc.png";